import { browserName, browserVersion } from 'react-device-detect';

export const isBrowserSupported = () => {
  const whiteList = [
    {
      name: 'Chrome',
      version: 91
    },
    {
      name: 'Firefox',
      version: 91
    },
    {
      name: 'Safari',
      version: 14
    },
    {
      name: 'Edge',
      version: 91
    }
  ];
  const selectedBrowser = whiteList.find(i => i.name === browserName);

  if (isNaN(+browserVersion)) {
    return false;
  }

  return selectedBrowser && selectedBrowser.version <= +browserVersion;
};
